import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  appointmentPage: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  userPage: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  dialog: { type: '', visible: false, loading: false },
  search: null,
  loading: false,
};

export default { namespaced:  true, state: initialState, actions, mutations } as IStore<IModuleState>;
